import {Component, EventEmitter, Injector, Input, OnInit, Output, ViewChild} from '@angular/core';
import {AppComponentBase} from '@shared/common/app-component-base';
import {
    ICreateOrUpdateVirtualBankDto,
    ICreateVirtualBankUserInputDtoWithId
} from '@shared/service-proxies/service-proxies';
import {ModalDirective} from 'ngx-bootstrap/modal';
import {finalize} from 'rxjs/operators';
import {FieldAgentService} from '@app/webshop/field-agent/shared/services/field-agent.service';
import {EditCustomerMode} from '@app/webshop/shared/models';

@Component({
    selector: 'editCustomerModal',
    templateUrl: './edit-customer-modal.component.html',
    styleUrls: ['./edit-customer-modal.component.less']
})
export class EditCustomerModalComponent extends AppComponentBase implements OnInit {
    protected readonly EditCustomerMode = EditCustomerMode;

    @ViewChild('editCustomerModal', {static: true}) modal: ModalDirective;

    @Output() onSubmit: EventEmitter<any> = new EventEmitter<any>();

    billingInfo = {} as ICreateOrUpdateVirtualBankDto;

    @Input() options?: any;

    active = false;
    saving = false;

    mode: EditCustomerMode = EditCustomerMode.Full;

    constructor(
        injector: Injector,
        private _fieldAgentService: FieldAgentService
    ) {
        super(injector);
    }

    ngOnInit(): void {
    }

    show(input: ICreateOrUpdateVirtualBankDto | undefined): ModalDirective {
        this.active = true;

        if (input) {
            this.billingInfo = input;
        }

        this.modal.show();
        return this.modal;
    }

    showWithMode(input: ICreateOrUpdateVirtualBankDto | undefined, mode: EditCustomerMode): void {
        //set Mode
        this.mode = mode;
        this.show(input);
    }

    onShown(): void {
        //document.getElementById('ProjectName').focus();
    }

    close(): void {
        this.active = false;
        this.modal.hide();
    }

    editCustomer(): void {
        this.saving = true;

        this._fieldAgentService
            .editCustomer$(this.billingInfo)
            .pipe(finalize(() => this.saving = false))
            .subscribe((data) => {
                //this.notify.info(this.ls('Plattform', 'Plattform.Invoice.EnvironmentSaved'));
                this.close();

                this.onSubmit.emit(null);
            });
    }

}


